/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './implant-property.reducer';

export const ImplantPropertyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const implantPropertyEntity = useAppSelector(state => state.implantProperty.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="implantPropertyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.implantProperty.detail.title">ImplantProperty</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.implantProperty.id">Id</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.id}</dd>
          <dt>
            <span id="key">
              <Translate contentKey="tinyMedicRestApp.implantProperty.key">Key</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.key}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.implantProperty.value">Value</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.value}</dd>
          <dt>
            <span id="group">
              <Translate contentKey="tinyMedicRestApp.implantProperty.group">Group</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.group}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.implantProperty.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.sortOrder}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.implantProperty.active">Active</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.implantProperty.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.implantProperty.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.implantProperty.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.implantProperty.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{implantPropertyEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implantProperty.implant">Implant</Translate>
          </dt>
          <dd>{implantPropertyEntity.implant ? implantPropertyEntity.implant.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/implant-property" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/implant-property/${implantPropertyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImplantPropertyDetail;
